<template>
  <div class="summary-yearly">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统统计</el-breadcrumb-item>
      <el-breadcrumb-item>数据下载年度统计</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <el-col>
        <el-card class="user-card">
          <div class="container">
            <div style="margin-bottom: 20px">
              <el-radio-group v-model="currentTab" size="medium">
                <el-radio-button label="数据量(TB)"></el-radio-button>
                <el-radio-button label="下载次数" ></el-radio-button>
                <el-radio-button label="统计折线图" ></el-radio-button>
              </el-radio-group>
            </div>
            <template v-if="currentTab === '数据量(TB)' || currentTab === '下载次数'">
              <el-table :data="dataList" style="width: 100%" @sort-change="sortChange">
                <el-table-column sortable="custom" prop="batch_num" label="批次"></el-table-column>
                <el-table-column sortable="custom" prop="year" label="年份"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_1' : 'times_m_1'" label="1月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_2' : 'times_m_2'" label="2月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_3' : 'times_m_3'" label="3月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_4' : 'times_m_4'" label="4月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_5' : 'times_m_5'" label="5月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_6' : 'times_m_6'" label="6月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_7' : 'times_m_7'" label="7月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_8' : 'times_m_8'" label="8月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_9' : 'times_m_9'" label="9月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_10' : 'times_m_10'" label="10月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_11' : 'times_m_11'" label="11月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_m_12' : 'times_m_12'" label="12月"></el-table-column>
                <el-table-column :prop="currentTab === '数据量(TB)' ? 'size_sum' : 'times_sum'" label="合计"></el-table-column>
              </el-table>
            </template>
            <template v-else>
              <div>
                <el-date-picker
                  @change="getMonthlyData"
                  v-model="mouthlyRange"
                  :unlink-panels="true"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd"
                  type="monthrange"
                  range-separator="-"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份">
                </el-date-picker>
                <el-row :gutter="20" style="margin-top: 20px;">
                  <el-col :span="24">
                    <el-card class="monthly-card">
                      <div id="monthly-times"></div>
                    </el-card>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 20px;">
                  <el-col :span="24">
                    <el-card class="monthly-card">
                      <div id="monthly-size"></div>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
            </template>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
  
<script>
import axios from 'axios'
import * as echarts from 'echarts'

let timesChart = null
let sizeChart = null

export default {
  name: 'SummaryYearlyData',
  data() {
    return {
      dataList: [],
      currentTab: '数据量(TB)',
      mouthlyRange: null,
      minDate: '',
      maxDate: '',
      pickerOptions: {
        disabledDate: (time) => {
          const minTime = new Date(this.minDate).getTime()
          const maxTime = new Date(this.maxDate).getTime()
          return (time.getTime() < minTime) || (time.getTime() > maxTime)
        },
      },
    }
  },
  created() {
    this.getData()
  },
  watch: {
    currentTab(val) {
      if (val === '统计折线图') {
        this.getMonthlyData(this.mouthlyRange)
      }
    }
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      axios.post('/iapi/getsummyyearlydata', params).then((res) => {
        if (res.data.errcode === 0) {
          this.dataList = res.data.data;
          this.dataList = res.data.data.map((item) => {
            let item_res = {...item};
            for (let i = 1; i <= 12; i++) {
              if (!item_res[`size_m_${i}`]) {
                item_res[`size_m_${i}`] = '-';
              }
              if (!item_res[`times_m_${i}`]) {
                item_res[`times_m_${i}`] = '-';
              }
            }
            if (!item['size_sum']) {
              item['size_sum'] = '-';
            }
            if (!item['times_sum']) {
              item['times_sum'] = '-';
            }
            return item_res;
          });
        }
      });
    },

    sortChange(v) {
      const order = v.order;
      const prop = v.prop;
      this.dataList.sort((a, b) => {
        if (a[prop] < b[prop]) {
          if (order === 'descending') {
            return 1
          } else {
            return -1
          }
        }
        if (a[prop] > b[prop]) {
          if (order === 'descending') {
            return -1
          } else {
            return 1
          }
        }
        return 0
      })
    },
    
    getMonthlyData(mouthlyRange=null) {
      const params = {}
      if (mouthlyRange) {
        params['mouthlyRange'] = mouthlyRange
      }
      axios.post('/iapi/getsummymonthly', params).then((res) => {
        if (res.data.errcode === 0) {
          this.minDate = res.data.data.minDate
          this.maxDate = res.data.data.maxDate
          let xData = res.data.data.date.map((item => item.date))
          let yData = res.data.data.data
          this.initChartTimes(xData, yData)
          this.initChartSize(xData, yData)
        }
      })
    },

    initChartTimes(xData, yData) {
      if(timesChart) {
        timesChart.dispose()
      }
      timesChart = echarts.init(document.getElementById('monthly-times'))
      const option = {
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: {
            align: 'center',
            formatter: (v) => {
              const vArr = v.split('-')
              return `${vArr[0]}年${vArr[1]}月`
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '下载次数',
          nameLocation: 'middle',
          nameGap: 36,
          nameRotate: 90,
          nameTextStyle: {
            fontSize: 14,
          },
        },
        legend: {
          bottom: 20,
          icon: 'roundRect',
          itemWidth: 30,
          itemHeight: 2,
        },
        tooltip: {
          trigger: 'axis',
          showContent: true,
        },
        grid: {
          top: 36,
          right: '5%',
        },
        series: Object.keys(yData).sort((a, b) => {
          if (a < b) return -1
          if (a > b) return 1
          return 0
        }).map((item) => {
          return {
            data: yData[item].map((d) => {
              return {
                name: d.date,
                value: d.times,
              }
            }),
            name: item,
            type: 'line',
            symbol: 'none',
          }
        })
      };
      timesChart.setOption(option)
    },

    initChartSize(xData, yData) {
      if(sizeChart) {
        sizeChart.dispose()
      }
      sizeChart = echarts.init(document.getElementById('monthly-size'))
      const option = {
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: {
            align: 'center',
            formatter: (v) => {
              const vArr = v.split('-')
              return `${vArr[0]}年${vArr[1]}月`
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '下载数据量(TB)',
          nameLocation: 'middle',
          nameGap: 36,
          nameRotate: 90,
          nameTextStyle: {
            fontSize: 14,
          },
        },
        legend: {
          bottom: 20,
          icon: 'roundRect',
          itemWidth: 30,
          itemHeight: 2,
        },
        tooltip: {
          trigger: 'axis',
          showContent: true,
        },
        grid: {
          top: 36,
          right: '5%',
        },
        series: Object.keys(yData).sort((a, b) => {
          if (a < b) return -1
          if (a > b) return 1
          return 0
        }).map((item) => {
          return {
            data: yData[item].map((d) => {
              return {
                name: d.date,
                value: d.size,
              }
            }),
            name: item,
            type: 'line',
            symbol: 'none',
          }
        })
      };
      sizeChart.setOption(option)
    },
  },
}
</script>

<style scoped>
.summary-yearly {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.admin-path {
  margin-bottom: 16px;
}
#monthly-size, #monthly-times {
  height: 480px;
}
</style>

<style>
.monthly-card .el-card__body {
  padding: 0;
}
</style>
